import { render, staticRenderFns } from "./ClassificacaoCliente.vue?vue&type=template&id=1825ab25"
import script from "./ClassificacaoCliente.vue?vue&type=script&lang=js"
export * from "./ClassificacaoCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports